<template>
  <div class="">
    <edit-cash-entries-deposit> </edit-cash-entries-deposit>
  </div>
</template>

<script>
import EditCashEntriesDeposit from "@/components/accounting/cash-entries/deposit/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "removeBreadcrumbs" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    EditCashEntriesDeposit,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Modifica Acconto",
        path: "movimenti_prima_nota.edit2",
        level: 4,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Modifica Acconto",
        path: "movimenti_prima_nota.edit2",
        level: 4,
      });
    }
  },
};
</script>
